import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Error al iniciar sesión");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-sunset-ink flex items-center justify-center px-5">
      <div className="w-full max-w-sm">
        <div className="text-center mb-10">
          <h1 className="font-serif text-4xl text-white tracking-tight">Sunset Magazine</h1>
          <p className="kicker text-white/50 mt-2">Panel de Administración</p>
        </div>
        <form onSubmit={submit} data-testid="admin-login-form" className="space-y-4">
          <input type="email" data-testid="login-email" value={email} onChange={(e) => setEmail(e.target.value)}
            placeholder="Correo electrónico" required
            className="w-full bg-white/10 border border-white/20 text-white placeholder:text-white/40 px-4 py-3.5 text-sm focus:outline-none focus:border-sunset-accent" />
          <input type="password" data-testid="login-password" value={password} onChange={(e) => setPassword(e.target.value)}
            placeholder="Contraseña" required
            className="w-full bg-white/10 border border-white/20 text-white placeholder:text-white/40 px-4 py-3.5 text-sm focus:outline-none focus:border-sunset-accent" />
          <button type="submit" data-testid="login-submit" disabled={loading}
            className="w-full bg-sunset-accent text-white uppercase tracking-wider text-xs font-semibold py-4 hover:bg-white hover:text-sunset-ink transition-colors disabled:opacity-50">
            {loading ? "Ingresando…" : "Iniciar sesión"}
          </button>
        </form>
      </div>
    </div>
  );
}
